// PRE LOADER
const overlay = document.querySelector(".overlay");
const line1 = document.querySelector('.line');
const line2 = document.querySelector('.line2');
const logoLoader = document.querySelector('.logo-loader');

// HOME
const hero = document.querySelector('[data-hero]')
const skip = document.querySelector('.skip-section');
//Slider
const sliderSvg = document.querySelector('.slider-svg');
const slidetTxt = document.querySelector('.slider-text');
const sliderBox = document.querySelector('.slider_box');
// TEXT E LOGO HOME
const h1Inside = document.querySelector(".hero-inside");
const h1Outside = document.querySelector(".hero-outside");
const textP = document.getElementById('outside-text');
const textP2 = document.getElementById('inside-text');
//nossos serviços
const textSrv = document.querySelector('.text-services');
const h1Srv = document.querySelector('.service_cta-title');
const boxSrv = document.querySelectorAll('.services_content-box');

//att area
const att01 = document.getElementById('att-01');
//CONTATO
const titleContato = document.querySelector('.contato-title h1');
const boxForm = document.querySelectorAll('.box-form');
const msg = document.getElementById('cf-message');
const btnForm = document.getElementById('cf-submit');
//FOOTER 
const logoFooter = document.querySelector('.box-logo-footer img');
const textFooter = document.querySelector('.cta-text');
const redesFooter = document.getElementById('redesFooter');
const text2Footer = document.querySelectorAll('.cta-contato');
const logoWeeFooter = document.querySelector('.logo-wee');
const copyFooter = document.querySelector('.box-weecom p');
const ancorFooter = document.querySelector('.ancor-topo');
/* Menu */
const menuButton = document.querySelector('[data-btn="menu"]')
const menu = document.querySelector('[data-menu]')
const logoWhite = document.querySelector('.logo-white');
const logoBlue = document.querySelector('.logo-blue');
const logoBox = document.querySelector('.logo');
const svgHero = document.querySelector('.hero_svg');
const body = document.querySelector('body');
//menu links
const link = document.getElementById('homeLink');
const link2 = document.getElementById('arcanjoLink');
const link3 = document.getElementById('attLink');
const link4 = document.getElementById('srvLink');
const link5 = document.getElementById('contatoLink');

menuButton.addEventListener('click', () => {
	menu.classList.toggle('is-open')
	menuButton.classList.toggle('is-active')
	logoWhite.classList.toggle('is-active')
	logoBlue.classList.toggle('is-active')
	logoBox.classList.toggle('is-active')
	svgHero.classList.toggle('is-active')
	skip.classList.toggle('ativo')
	body.classList.toggle('ativo')
});
link5.addEventListener('click', () => {
	menu.classList.toggle('is-open')
	menuButton.classList.toggle('is-active')
	logoWhite.classList.toggle('is-active')
	logoBlue.classList.toggle('is-active')
	logoBox.classList.toggle('is-active')
	svgHero.classList.toggle('is-active')
	skip.classList.toggle('ativo')
	body.classList.toggle('ativo')
})
link4.addEventListener('click', () => {
	menu.classList.toggle('is-open')
	menuButton.classList.toggle('is-active')
	logoWhite.classList.toggle('is-active')
	logoBlue.classList.toggle('is-active')
	logoBox.classList.toggle('is-active')
	svgHero.classList.toggle('is-active')
	skip.classList.toggle('ativo')
	body.classList.toggle('ativo')
})
link3.addEventListener('click', () => {
	menu.classList.toggle('is-open')
	menuButton.classList.toggle('is-active')
	logoWhite.classList.toggle('is-active')
	logoBlue.classList.toggle('is-active')
	logoBox.classList.toggle('is-active')
	svgHero.classList.toggle('is-active')
	skip.classList.toggle('ativo')
	body.classList.toggle('ativo')
})
link2.addEventListener('click', () => {
	menu.classList.toggle('is-open')
	menuButton.classList.toggle('is-active')
	logoWhite.classList.toggle('is-active')
	logoBlue.classList.toggle('is-active')
	logoBox.classList.toggle('is-active')
	svgHero.classList.toggle('is-active')
	skip.classList.toggle('ativo')
	body.classList.toggle('ativo')
})
link.addEventListener('click', () => {
	menu.classList.toggle('is-open')
	menuButton.classList.toggle('is-active')
	logoWhite.classList.toggle('is-active')
	logoBlue.classList.toggle('is-active')
	logoBox.classList.toggle('is-active')
	svgHero.classList.toggle('is-active')
	skip.classList.toggle('ativo')
	body.classList.toggle('ativo')
})


// MEDIA QUERY 
function myFunction(x) {
	if (x.matches) { // If media query matches



		/* Timeline */
		const tl = gsap.timeline()

		tl
			.to([line1, line2], {
				width: '50vw',
				duration: 1.5,
				ease: 'sine.out',
			})
			.to(logoLoader, {
				opacity: 0,
				ease: 'sine.out',
			}, 1)
			.to([line1, line2], {
				height: '100vh',
				duration: 0.5,
				ease: 'back.out(2)',
				delay: 0.5,
			})
			.to(overlay, {
				display: 'none',
				ease: 'sine.out',
				duration: 0.01,
			})
			.to(hero, {
				'--maskSize1': '10%',
				duration: 0.5,
				ease: 'back.out(2)',
			})
			.to(hero, {
				'--maskSize2': '15%',
				'--maskSize3': 'calc(15% + 0.1rem)',
				duration: 0.5,
				delay: 0.5,
				ease: 'back.out(2)',
			})


		/* Cursor */


		window.addEventListener('mousemove', (e) => {
			const { clientX, clientY } = e
			const x = Math.round((clientX / window.innerWidth) * 100)
			const y = Math.round((clientY / window.innerHeight) * 100)

			gsap.to(hero, {
				'--x': `${x}%`,
				'--y': `${y}%`,
				duration: 0.3,
				ease: 'sine.out',
			})

		})

		// texto e logo home
		const tl2 = gsap.timeline()
		tl2
			.to(logoBlue, {
				opacity: 1,
				duration: 1,
				delay: 3,
				y: 0,
				ease: "expo.out",
			})
			.to([h1Outside, h1Inside], {
				opacity: 1,
				duration: 0.5,
			})
		tl2.to([textP, textP2], {
			opacity: 1,
			duration: 0.5,
		})

		// svg home

		let paths = document.querySelectorAll(".hero_svg path");
		const pathsArr = Array.from(paths);
		paths.forEach(function (item, index) {
			let pathLenght = item.getTotalLength();
			item.setAttribute("stroke-dasharray", pathLenght);
			item.setAttribute("stroke-dashoffset", pathLenght);
			gsap.to(item, {
				strokeDashoffset: 0,
				ease: 'sine.out',
				duration: 2.5,
				delay: 3,
			})
		});

		//area de atuação


		//area de atuação
		// Scroll Scenes 
		const scenes = gsap.utils.toArray('.scene');

		// maybe use dymanic height for pin/scroll ends?
		const height = ((scenes.length - 1) * 200) + '%';

		// Scenes Timeline
		const pinTl = gsap.timeline({
			scrollTrigger: {
				trigger: ".scenes__items",
				pin: ".scenes",
				start: "top",
				end: `+=${height}`,
				// onEnterBack: () => startVideo(scenes[scenes.length - 1]),
				scrub: true,
			},

		});

		// Set scenes wrapper to absolute
		gsap.set(scenes, { position: "absolute", top: 0 });

		// Loop over scenes
		scenes.forEach(function (elem, i) {

			// Vid start / pause logic
			pinTl.add(() => pinTl.scrollTrigger.direction > 0 ? startVideo(elem, i) : stopVideo(elem, i), i + 0.001);

			if (i != 0) {
				// Scene Enter animations
				gsap.registerPlugin(ScrollTrigger);
				pinTl.from(elem.querySelector('.scene__figure'), {
					opacity: 1,
					scrollTrigger: elem.querySelector('.scene__figure')
				}, i
				)

				pinTl.from(elem.querySelector('.scene__header'), {
					autoAlpha: 0,
					translateY: 100
				}, i
				)
			}
			// Scene Exit animations
			if (i != scenes.length - 1) {
				pinTl.to(elem.querySelector('.scene__header'), {
					autoAlpha: 0,
					translateY: -100
				}, i + 0.75
				)
				pinTl.to(elem.querySelector('.scene__figure'), {

				},
				)
			}

			// Vid start / pause logic
			pinTl.add(() => pinTl.scrollTrigger.direction > 0 ? stopVideo(elem, i) : startVideo(elem, i), i + 1.25);

		});

		// add a tiny amount of empty space at the end of the timeline so that the playhead trips the final callback in both directions
		pinTl.to({}, { duration: 0.001 });

		/** 
		 * Start Video 
		 * @param {HTML ELement} - element containing video
		 */
		function startVideo(vidScene, i) {
			const vid = vidScene.querySelector('video');
			if (vid) {
				// console.log("Start Vid", vid)
				vid.play()
			}
		}

		/** 
		 * Stop Video 
		 * @param {HTML ELement} - element containing video
		 */
		function stopVideo(vidScene, i) {
			const vid = vidScene.querySelector('video');
			if (vid) {
				// console.log("end vid", vid)
				vid.pause()
			}
		};

		const att = document.getElementById('att');
		const titleAtt = document.querySelector('.title-att');
		gsap.registerPlugin(ScrollTrigger);
		gsap.to(titleAtt, {
			scrollTrigger: {
				trigger: ".scenes__items",
				start: "top",
				end: `+=${height}`,
			},
			x: 0,
			opacity: 1,
			duration: 2
		});


		///adv hover
		// const boxHover = document.querySelectorAll('.box_redes');
		// gsap.registerPlugin(ScrollTrigger);
		// gsap.fromTo(boxHover, {y: -100, opacity:0, scrollTrigger:boxHover}, {opacity:1, y : 0, duration: 1});
		const fraseHover = document.querySelector('.frase_box');
		const trigHover = document.querySelector('.frase_adv');
		gsap.registerPlugin(ScrollTrigger);
		gsap.to(fraseHover, {
			scrollTrigger: {
				trigger: trigHover,
				start: "-=700",
				end: "+=700",
				scrub: true,
			},
			opacity: 1,
			duration: 2
		})




		//nossos serviços
		gsap.registerPlugin(ScrollTrigger);
		const tlService = gsap.timeline({
			scrollTrigger: {
				trigger: textSrv,
			}
		})
		let servicePath = document.querySelectorAll(".services-svg path");
		const servicePathArr = Array.from(servicePath);
		servicePath.forEach(function (item, index) {
			let pathLenght = item.getTotalLength();
			item.setAttribute("stroke-dasharray", pathLenght);
			item.setAttribute("stroke-dashoffset", pathLenght);
			tlService
				.to(item, {
					strokeDashoffset: 0,
					ease: "power1.out",
					duration: .4,
					stagger: {
						amount: 0.2
					}

				})
				.fromTo(textSrv, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .8 }, .5)
				.fromTo(h1Srv, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .8 }, .5)
				.fromTo(boxSrv, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .8 }, .8)

		});

		//slider

		gsap.registerPlugin(ScrollTrigger);
		const tlSlider = gsap.timeline({
			scrollTrigger: {
				trigger: sliderSvg,
			}
		})
		let sliderPath = document.querySelectorAll(".slider-svg path");
		const sliderPathArr = Array.from(sliderPath);
		sliderPath.forEach(function (item, index) {
			let pathLenght = item.getTotalLength();
			item.setAttribute("stroke-dasharray", pathLenght);
			item.setAttribute("stroke-dashoffset", pathLenght);
			tlSlider
				.to(item, {
					strokeDashoffset: 0,
					ease: "sine.out",
					duration: .5,
				})
				.fromTo(slidetTxt, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .8 }, .5)
				.fromTo(sliderBox, { opacity: 0 }, { opacity: 1, duration: .8 }, .5)

		});


		//contato
		const ctText = document.querySelector('.contato-text p');
		gsap.registerPlugin(ScrollTrigger);
		const tlContato = gsap.timeline({
			scrollTrigger: {
				trigger: titleContato,
			}
		})
		tlContato
			.fromTo(titleContato, { x: -10, opacity: 0 }, { opacity: 1, x: 0, duration: .8 })
			.fromTo(ctText, { x: 10, opacity: 0 }, { opacity: 1, x: 0, duration: .5 })
			.fromTo(boxForm, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .5 })
			.fromTo(msg, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .5 })
			.fromTo(btnForm, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .5 })
		//footer

		gsap.registerPlugin(ScrollTrigger);
		const tlFooter = gsap.timeline({
			scrollTrigger: {
				trigger: logoFooter,
			}
		})
		tlFooter
			.fromTo(logoFooter, { x: -10, opacity: 0 }, { opacity: 1, x: 0, duration: .5 })
			.fromTo(textFooter, { x: -10, opacity: 0 }, { opacity: 1, x: 0, duration: .5 }, ">")
			.fromTo(redesFooter, { x: 10, opacity: 0 }, { opacity: 1, x: 0, duration: .5 }, ">")
			.fromTo(text2Footer, { x: 10, opacity: 0 }, { opacity: 1, x: 0, duration: .5 }, ">");

		gsap.registerPlugin(ScrollTrigger);
		const tlCopy = gsap.timeline({
			scrollTrigger: {
				trigger: logoWeeFooter,
			}
		})
		tlCopy
			.fromTo(logoWeeFooter, { scale: 0, opacity: 0 }, { opacity: 1, scale: 1, duration: .5 })
			.fromTo(copyFooter, { opacity: 0 }, { opacity: 1, x: 0, duration: .5 })
			.fromTo(ancorFooter, { y: -100, opacity: 0 }, { opacity: 1, y: 0, duration: .5 })







	} else {
		///////////////////////////////////////////////////////////////////////////////////////////
		////////////////////////// MOBILE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		const tl = gsap.timeline()

		tl
			.to([line1, line2], {
				width: '100vw',
				duration: 1.2,
				ease: 'sine.out',
			})
			.to(logoLoader, {
				opacity: 0,
				ease: 'sine.out',
				duration: .5,
			}, "<")
			.to([line1, line2], {
				height: '100vh',
				duration: 0.5,
				ease: 'back.out(2)',
				delay: 0.5,
			})
			.to(overlay, {
				display: 'none',
				ease: 'sine.out',
				duration: 0.01,
			})


		const tl2 = gsap.timeline()
		tl2
			.to(logoBlue, {
				opacity: 1,
				duration: 1,
				delay: 3,
				y: 0,
				ease: "expo.out",
			})
			.to([h1Outside, h1Inside], {
				opacity: 1,
				duration: 0.5,
			})
		tl2.to([textP, textP2], {
			opacity: 1,
			duration: 0.5,
		})



		let paths = document.querySelectorAll("svg path");
		const pathsArr = Array.from(paths);
		paths.forEach(function (item, index) {
			let pathLenght = item.getTotalLength();
			item.setAttribute("stroke-dasharray", pathLenght);
			item.setAttribute("stroke-dashoffset", pathLenght);
			gsap.to(item, {
				strokeDashoffset: 0,
				ease: 'sine.out',
				duration: 2.5,
				delay: 3,
			})
		});




	}
}

var x = window.matchMedia("(min-width: 1100px)")
myFunction(x) // Call listener function at run time
x.addListener(myFunction) // Attach listener function on state changes




/*Mapa*/
// Creating map options
const lat = document.getElementById('lat').value;
const lng = document.getElementById('lng').value;
const address = document.getElementById('address').value;
const markerIcon = document.getElementById('marker').value;
const backgroundSvg = document.getElementById('backgroundSvg').value;
var map = L.map('mapa').setView([lat,lng], 17);

// Creating a Layer object
var layer = new L.TileLayer(
	"http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
);
// Adding layer to the map
map.addLayer(layer);

let customIcon = {
	iconUrl: markerIcon,
	iconSize: [58, 175],
	popupAnchor: [0, -67],
	setZIndex: 10,
}
let myIcon = L.icon(customIcon);

let iconOptions = {
	title: 'Arcanjo Neto Sociedade Individual de Advocacia',
	draggable: false,
	icon: myIcon,
}
let marker = new L.Marker([lat,lng], iconOptions);
marker.addTo(map)
marker.bindPopup(`<p style="font-family: 'Poppins', sans-serif;">
<strong style='color:#939460;' >
		Arcanjo Neto Sociedade
		<br>
		Individual de Advocacia
</strong>
<br>
<br>
<span style="color:gray;" >
	${address}
</span>
</p>`).openPopup()



var imageUrl = backgroundSvg,
imageBounds = [[-65.9, -175.1], [84.0, 176.0]];
L.imageOverlay(imageUrl, imageBounds,{
	opacity: 0.9,
	className: 'background-maps'
}).addTo(map);

const mapa = document.querySelector('#mapa')
mapa.addEventListener('mouseover', ()=>{
	gsap.to('.background-maps', {
		opacity: 0,
		duration: .4,
	})
})
mapa.addEventListener('mouseout', ()=>{
	gsap.to('.background-maps', {
		opacity: 0.9,
		duration: .4,
	})
})


// dynamic year
document.addEventListener("DOMContentLoaded", function() {
	var yearElement = document.getElementById("year");
	var currentYear = new Date().getFullYear();
	yearElement.textContent = currentYear;
});

/*
`<div style='width: 100%; height: 100%; background-color: rgba(27, 37, 68, 0.821);'></div>`
*/
